import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NuevaComponent } from './nueva/nueva.component';

const routes: Routes = [ { path: 'nueva/:tipo', component: NuevaComponent, data: {title: 'CONVOCATORIA'}}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConvocatoriasRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/modules/convocatorias/convocatorias-routing.module.ts